import { ActivatedRouteSnapshot } from '@angular/router';

export function getActivatedComponent(snapshot: ActivatedRouteSnapshot): any  {

  return snapshot.firstChild ? getActivatedComponent(snapshot.firstChild) : snapshot.component;

}

export function getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
  const path = '';
  if (snapshot.routeConfig) {
    path.concat(snapshot.routeConfig.path);
  }

  if (snapshot.firstChild) {
    return path.concat(getRouteTemplate(snapshot.firstChild));
  }

  return path;

}
